'use strict'

var Marionette = require('marionette')
var App = require('app')
var _ = require('lodash')

var View = require('./view.js')
var PageModel = require('src/common/page-model')
var BodyModel = require('src/common/page-model')

var ClientsList = function () {
  var Controller = Marionette.Object.extend({
    initialize: function () {
      var self = this

      // this.container = options.container
      self.clients = App.globalChannel.request('client:entities')

      //
      var pageModel = new PageModel({
        title: 'Clients',
        buttons: [
          { label: 'add client', primary: true, slug: 'client', action: 'client:add', roles: ['super', 'admin'] }
        ]
      })

      self.layout = self.getLayoutView(pageModel)

      self.listenTo(self.layout, 'client:add', _.bind(self.onAdd, self))
      self.listenTo(self.layout, 'render', _.bind(self.bodyRegion, self))
      //
      App.rootLayout.showChildView('mainRegion', self.layout)
    },
    /* Event methods --------------------------------------------------------- */
    onAdd: function (args) {
      App.globalChannel.trigger('client:new', {region: App.rootLayout.getRegion('dialogRegion'), collection: this.clients})
    },
    onManage: function (args) {
      App.globalChannel.trigger('client:show', {model: args.options.model})
    },
    onEdit: function (args) {
      App.globalChannel.trigger('client:edit', {region: App.rootLayout.getRegion('dialogRegion'), model: args.options.model})
    },
    /* Regions --------------------------------------------------------------- */
    listRegion: function () {
      var self = this
      //
      var columns = {
        'name': { 'label': 'name', 'sortable': true, 'roles': [] },
        'nodes': { 'label': 'nodes', 'sortable': false, 'roles': [] },
        '_actions': {
          'options': {
            'edit': { 'action': 'edit', 'roles': [] },
            'manage': { 'action': 'manage', 'roles': [] }
          }
        }
      }

      //
      var layout = this.getListView(self.clients, columns)
      self.listenTo(layout, 'listview:childview:item:edit', _.bind(self.onEdit, self))
      self.listenTo(layout, 'listview:childview:item:manage', _.bind(self.onManage, self))

      self.bodyLayout.getRegion('listRegion').show(layout)
    },
    bodyRegion: function () {
      var self = this

      var bodyModel = new BodyModel({})

      self.bodyLayout = self.getBodyView(bodyModel)
      self.listenTo(self.bodyLayout, 'render', function () {
        self.listRegion()
      })
      self.layout.showChildView('bodyRegion', self.bodyLayout)
    },
    /* Views ----------------------------------------------------------------- */
    getBodyView: function (model) {
      return new View.BodyLayout({model: model})
    },
    getListView: function (collection, columns) {
      // create the listview based on the list component
      return new View.ListView({
        collection: collection,
        columns: columns,
        childView: View.ListItem // use a custom childview
      })
    },
    getLayoutView: function (pageModel) {
      return new View.Layout({pageModel: pageModel})
    }
  })

  return new Controller()
}

module.exports = ClientsList



// WEBPACK FOOTER //
// ./js/modules/page-clients/list/index.js